const StagingRequestInterceptor = (config: any) => {
	const url = config.baseURL + config.url;
	const regex = new RegExp(atob('Xmh0dHBzOi8vLis/XC5zdGFnaW5nXC4oZmVhdClcLihhZ2VuY3kp'));
	const matches = regex.exec(url);

	if (matches) {
		config[atob('YXV0aA==')] = {};
		config[atob('YXV0aA==')][atob('dXNlcm5hbWU=')] = matches[1];
		config[atob('YXV0aA==')][atob('cGFzc3dvcmQ=')] = matches[2];
	}

	return config;
};

export default StagingRequestInterceptor;
